import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import connect from '../../../../../core/EcrionProvider/connect';
import _logoutUser from '../../../actions/logoutUser';
import { getDisplayName } from '../../../util';
import User from './User';
import Utils from '../../../../../utils';
/**
 * @extends {React.Component<Props>}
 */

var UserContainer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(UserContainer, _React$Component);

  function UserContainer() {
    _classCallCheck(this, UserContainer);

    return _possibleConstructorReturn(this, _getPrototypeOf(UserContainer).apply(this, arguments));
  }

  _createClass(UserContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          auth = _this$props.auth,
          userInfo = _this$props.userInfo,
          logoutUser = _this$props.logoutUser,
          restProps = _objectWithoutProperties(_this$props, ["auth", "userInfo", "logoutUser"]);

      var ecrionServer = auth.microserviceId ? Utils.getHost() : '/';
      var entries = [[{
        label: 'My Account',
        props: {
          href: ecrionServer + 'home/account' + '?environment=' + encodeURIComponent(userInfo.environmentName)
        },
        permissions: []
      }, {
        label: 'Organization',
        props: {
          href: ecrionServer + 'home/organization' + '?environment=' + encodeURIComponent(userInfo.environmentName)
        },
        permissions: ['ManageEnvironment']
      }], [{
        label: 'Manage Users',
        props: {
          href: ecrionServer + 'home/users' + '?environment=' + encodeURIComponent(userInfo.environmentName)
        },
        permissions: ['ManageEnvironment']
      }, {
        label: 'Explore Apps',
        props: {
          href: ecrionServer + 'home/apps' + '?environment=' + encodeURIComponent(userInfo.environmentName)
        },
        permissions: ['ManageEnvironment']
      }], [{
        label: 'Logout',
        type: 'button',
        props: {
          onClick: logoutUser
        },
        permissions: []
      }]];
      entries = entries.map(function (group) {
        return group.filter(function (entry) {
          return entry.permissions.every(function (permission) {
            return userInfo.permissions.includes(permission);
          });
        });
      });
      return React.createElement(User, Object.assign({
        drawerEntries: entries,
        userDisplayName: getDisplayName(userInfo),
        userProfileImage: userInfo.userProfileImage
      }, restProps));
    }
  }]);

  return UserContainer;
}(React.Component);
/**
 * @typedef {Object} Props
 *
 * @property {React.ElementType} [linkComponent]
 *
 * @property {Object} [userInfo] Injected by HoC
 * @property {Object} [auth] Injected by HoC
 * @property {Object} [classes] Injected by HoC
 * @property {Function} [dispatch] Injected by HoC
 * @property {Function} [logoutUser] Injected by HoC
 * @property {Object} [theme] Injected by HoC
 */


export default connect(function (state) {
  return {
    userInfo: state.userInfo,
    auth: state.auth
  };
}, function (dispatch) {
  return {
    logoutUser: function logoutUser() {
      return dispatch(_logoutUser());
    }
  };
})(UserContainer);